import React from 'react';
import { Card as BootstrapCard, Button } from 'react-bootstrap';
import { IMachine } from '../interfaces/IMachine';
import { Card } from './Card';

interface IMachineProps {
    machine: IMachine;
    onDeleteClick: (machine: IMachine) => void;
}

export const Machine = ({ machine, onDeleteClick }: IMachineProps) => {
    return (
        <Card>
            <BootstrapCard.Body>
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <BootstrapCard.Title>{machine.name}</BootstrapCard.Title>
                        <BootstrapCard.Text>
                            Locations: {machine.locationCount}
                        </BootstrapCard.Text>
                    </div>
                    <Button variant="danger" onClick={() => onDeleteClick(machine)}>Delete</Button>
                </div>
            </BootstrapCard.Body>
        </Card>
    );
}
